import React, {useContext, useEffect, useState} from "react";
import PrintingComponent from "../../../components/printingComponent";
import {MainContext} from "../../../context/MainContext";
import PresenceReport from "./PresenceReport";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import Async from "react-select/async";
import api from "../../../services/api";
import Select from "react-select";
import {attendanceRecord} from "./attendanceRecord";
import MembershipReportPDF from "./EbMembershipReport";
import { pdf } from '@react-pdf/renderer';

export default function PresenceReportComponent({ athleteId }:any) {
    const {club} = useContext(MainContext)

    const INITIAL_DATA = {
        value: 0,
        label: 'Selecione o Sócio',
    };

    const [print, setPrint] = useState<any>({})
    const [modelo, setModelo] = useState<string>('default')
    const [startDate, setStartDate] = useState<any>(dayjs().subtract(1, 'month').startOf('month'))
    const [endDate, setEndDate] = useState<any>(dayjs().subtract(1, 'month').endOf('month'))


    const [order, setOrder] = useState<any>("capture_timestamp desc")
    const [athlete, setAthlete] = useState(INITIAL_DATA);


    const childToParent = (childdata:any) => {
        setPrint({imprimir:false})
    }

    const validateFilters = () => {
        if (!startDate) {
            throw "Data inicial deve ser informada";
        }

        if (!endDate) {
            throw "Data final deve ser informada";
        }
    }

    const buildFiltro = () => ({
        period: {
            startDate: dayjs(startDate).format('YYYY-MM-DD'),
            endDate: dayjs(endDate).format('YYYY-MM-DD')
        },
        athlete: athlete?.value,
        order: order
    })

    async function openPdfExercito() {
        try {
            const response = await api.post(`/api/app/presence/report`, { filtro: buildFiltro() })
            const blob = await pdf(<MembershipReportPDF athletes={response.data} club={club} startDate={startDate} />).toBlob()
            window.open(URL.createObjectURL(blob), '_blank')
        } catch (err: any) {
            Swal.fire({ title: 'Erro!', text: err?.message || err, icon: 'error' })
        }
    }

    const validatePrint = (modelo = 'default') => {
        try {
            validateFilters()
            setModelo(modelo)
            setPrint({ imprimir: true })
        }catch (err: any) {
            Swal.fire({
                title: 'Erro!',
                text: err,
                icon: 'error',
            })
        }
    }

    async function members(value = '') {
        const response = await api.get(`/api/athletes/getToSelect/?search=${value}`)
        const result = await response
        return await result.data.map((athlete:any) => ({
            label: `${athlete.member_number || ""} - ${athlete.full_name}`,
            value: athlete.id
        }))
    }

    // useEffect(() => {
        // setPageTitle("Relatório de Presenças")
    // }, [])

    return (
        <>
            <div>
                {/*<div className="card">*/}
                {/*    <div className="card-body">*/}
                        {/*<h5 className="card-title">Filtros</h5>*/}

                        <div className="row g-3 mt-3">
                            <div className="col-lg-12">
                                <div className="row g-3">
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                                        <div className="col-md-2">
                                            <label htmlFor="startDate" className="form-label">Data inicial <i
                                                className="text-danger"> *</i></label>
                                            <DesktopDatePicker className={"form-control sadate"}
                                                        value={startDate}
                                                        onChange={evento => setStartDate(evento)}/>
                                        </div>

                                        <div className="col-md-2">
                                            <label htmlFor="endDate" className="form-label">Data final <i
                                                className="text-danger"> *</i></label>
                                            <DesktopDatePicker className={"form-control sadate"}
                                                        value={endDate}
                                                        onChange={evento => setEndDate(evento)}/>
                                        </div>
                                    </LocalizationProvider>

                                    <div className="col-md-2">
                                        <label htmlFor="order" className="form-label">Ordenar por</label>
                                        <Select
                                            defaultValue={{label: 'Data', value: "capture_timestamp desc"}}
                                            options={[{label: 'Data', value: "capture_timestamp desc"}, {
                                                label: 'Sócio',
                                                value: "at.full_name asc, a.capture_timestamp desc"
                                            }]}
                                            value={[{label: 'Data', value: "capture_timestamp desc"}, {
                                                label: 'Sócio',
                                                value: "at.full_name asc, a.capture_timestamp desc"
                                            }
                                            ].find(option => option.value == order)}
                                            name='order'
                                            id='order'
                                            onChange={(data: any) => {
                                                setOrder(data.value)
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="endDate" className="form-label">Sócio</label>
                                        <Async
                                            name="search"
                                            autoFocus={false}
                                            isClearable
                                            cacheOptions
                                            loadOptions={members}
                                            placeholder={"Selecione o Sócio"}
                                            noOptionsMessage={() => "Nenhum registro encontrado"}
                                            onChange={(data: any) => {
                                                setAthlete(data)
                                            }}
                                            value={athlete}
                                            defaultOptions
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className=" mt-3">
                            <div className="btn-group">
                                <button type="button" className="btn btn-primary" onClick={() => validatePrint()}><i className="bi bi-printer-fill"></i> Imprimir</button>
                                <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="#" onClick={openPdfExercito}>Modelo exército (PDF)</a></li>
                                    {/*<li><a className="dropdown-item" href="#" onClick={() => validatePrint("exercito")}>Modelo exército (HTML)</a></li>*/}
                                </ul>
                            </div>

                            <button className={"btn btn-warning mx-2"} onClick={() => attendanceRecord({
                                period: {
                                    startDate: dayjs(startDate).format('YYYY-MM-DD'),
                                    endDate: dayjs(endDate).format('YYYY-MM-DD')
                                },
                                athlete: athlete?.value,
                                order: order
                            }, club)}>
                                <i className="bi bi-filetype-xlsx"></i>  Exportar planilha
                            </button>
                        </div>
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            {print.imprimir &&
                <PrintingComponent componentToPrint={<PresenceReport filtro={{
                    period: {
                        startDate: dayjs(startDate).format('YYYY-MM-DD'),
                        endDate: dayjs(endDate).format('YYYY-MM-DD')
                    },
                    athlete: athlete?.value,
                    order: order
                }} modelo={modelo} />} textButon={""} orientation ={modelo == 'default' ? "":"landscape"} childToParent={childToParent}/>
            }
        </>
    )
}
